module.exports = __webpack_public_path__ + "images/cyber-kid.be38be23.webp";